import _jsx from "@babel/runtime/helpers/jsx";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _dec, _dec2, _class, _class2, _RemoveIcon, _br, _br2, _br3, _br4;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import _ from 'lodash';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import { bindActionCreators } from 'redux';
import { withCookies, Cookies } from 'react-cookie';
import NoSsr from '@mui/material/NoSsr';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Modal from '@mui/material/Modal';
import SaveIcon from '@mui/icons-material/Save';
import RemoveIcon from '@mui/icons-material/Delete';
import PrintIcon from '@mui/icons-material/Print';
import SyncIcon from '@mui/icons-material/Sync';
import Snackbar from '@mui/material/Snackbar';
import ShareIcon from '@mui/icons-material/Share';
import AppContext from '../../context';
import VismaSign from '../../components/statelessComponents/Icons/VismaSign';
import RestrictedAccessModal from '../../components/RestrictedAccessModal/RestrictedAccessModal';
import AddVismaSIgnModal from '../../components/AddVismaSignModal/AddVismaSIgnModal';
import { isSupportAdminAuth, isAllowedToTeacherCreateBundleCert, isTrial } from '../../helpers';
import * as certActions from '../../actions/cert';
import s from './Cert.scss';
import PdfViewer from '../../components/PdfViewer/PdfViewer';
import CustomModal from '../../components/Modals/Modal';
import VISMA_DOC_STATUSES from '../../constants/vismaDocStatuses';
import SignatureStatus from './SignatureStatus/SignatureStatus';
import BundleCertDetails from '../../components/BundleCertDetails/BundleCertDetails';
import { ViewIcon } from '../../components/statelessComponents/Icons';
import history from '../../history';
import ConfirmDeleteDialog from '../../components/statelessComponents/ConfirmDeleteDialog';
import ResendVismaSignInvitation from '../../components/ResendVismaSignInvitation/ResendVismaSignInvitation';
import ShareCertificateModal from '../../components/ShareCertificateModal/ShareCertificateModal';
import intlPropTypes from '../../constants/intlPropTypes';
var messages = defineMessages({
  download: {
    id: "Cert.download",
    defaultMessage: [{
      "type": 0,
      "value": "Download"
    }]
  },
  print: {
    id: "Cert.print",
    defaultMessage: [{
      "type": 0,
      "value": "Print"
    }]
  },
  regenerate: {
    id: "Cert.regenerate",
    defaultMessage: [{
      "type": 0,
      "value": "Regenerate"
    }]
  },
  certificateWillBeGeneratedSoon: {
    id: "Cert.certificateWillBeGeneratedSoon",
    defaultMessage: [{
      "type": 0,
      "value": "Certificate image will be generated soon"
    }]
  },
  trial: {
    id: "Cert.trial",
    defaultMessage: [{
      "type": 0,
      "value": "Trial account"
    }]
  },
  vismaSignTooltip: {
    id: "Cert.vismaSignTooltip",
    defaultMessage: [{
      "type": 0,
      "value": "Add Visma digital signature"
    }]
  },
  vismaSignLabel: {
    id: "Cert.vismaSignLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Add Visma sign"
    }]
  },
  showDetailsLabel: {
    id: "Cert.showDetailsLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Show details"
    }]
  },
  showDetailsTooltip: {
    id: "Cert.showDetailsTooltip",
    defaultMessage: [{
      "type": 0,
      "value": "Show certificate collection details"
    }]
  },
  confirmRemoveTitle: {
    id: "Cert.confirmRemoveTitle",
    defaultMessage: [{
      "type": 0,
      "value": "This action is irreversible. Are you sure?"
    }]
  },
  removeCertificateBtnLabel: {
    id: "General.removeTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Remove"
    }]
  },
  removingDescription: {
    id: "Cert.removingDescription",
    defaultMessage: [{
      "type": 0,
      "value": "By confirming this, the certificate will be removed, and it will be impossible to restore it."
    }]
  },
  removingDescriptionWithVismaWarn: {
    id: "Cert.removingDescriptionWithVismaWarn",
    defaultMessage: [{
      "type": 0,
      "value": "This certificates is related to Visma digital signature, by confirming this, the certificate will be removed, Visma sign invitation canceled, document removed from Visma service and it will be impossible to restore it."
    }]
  },
  shareBtn: {
    id: "Cert.share",
    defaultMessage: [{
      "type": 0,
      "value": "Share"
    }]
  }
});
var Cert = (_dec = connect(function (state) {
  return {
    auth: state.auth,
    loading: state.cert.loading,
    cert: state.cert.cert,
    user: state.editUser.user,
    locale: state.intl.locale
  };
}, function (dispatch) {
  return bindActionCreators(_objectSpread({}, certActions), dispatch);
}), _dec2 = withStyles(s), injectIntl(_class = withCookies(_class = _dec(_class = _dec2(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(Cert, _React$Component);
  var _super = _createSuper(Cert);
  function Cert() {
    var _this;
    _classCallCheck(this, Cert);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isRegenerating: false,
      isRestrictedAccessModalOpened: false,
      isAddVismaSignModalOpened: false,
      isBundleCertDetailsOpened: false,
      isConfirmDeleteOpen: false,
      isRemoving: false,
      removingErr: '',
      isShareModalOpened: false
    });
    _defineProperty(_assertThisInitialized(_this), "refreshVismaSign", function () {
      var _this$props = _this.props,
        getCert = _this$props.getCert,
        cert = _this$props.cert;
      return getCert(cert.code);
    });
    _defineProperty(_assertThisInitialized(_this), "print", function () {
      window.print();
    });
    _defineProperty(_assertThisInitialized(_this), "initWs", function () {
      var _this$props2 = _this.props,
        setCert = _this$props2.setCert,
        cert = _this$props2.cert;
      _this.ws = _this.context.initWs();
      _this.ws.on('certificate_image_generated', function (certificate) {
        if (_.get(certificate, '_id') !== cert._id) {
          return;
        }
        setCert(certificate);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "regenerate", function () {
      var _this$props3 = _this.props,
        cert = _this$props3.cert,
        getCert = _this$props3.getCert;
      _this.setState({
        isRegenerating: true
      });
      return _this.context.fetch("/api/certificates/".concat(cert._id, "/regenerate"), {
        method: 'PUT'
      }).then(function (res) {
        if (res.ok) {
          getCert(cert.code);
        }
        _this.setState({
          isRegenerating: false
        });
      })["catch"](function (err) {
        console.error(err);
        _this.setState({
          isRegenerating: false
        });
      });
    });
    _defineProperty(_assertThisInitialized(_this), "removeBundleCertificate", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var cert, organizationSlug, res, resJson;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            cert = _this.props.cert;
            organizationSlug = _this.context.organizationSlug;
            _this.setState({
              isRemoving: true
            });
            _context.prev = 3;
            _context.next = 6;
            return _this.context.fetch("/api/certificates/".concat(cert._id), {
              method: 'DELETE'
            });
          case 6:
            res = _context.sent;
            if (!res.ok) {
              _context.next = 9;
              break;
            }
            return _context.abrupt("return", history.push("/".concat(_this.props.locale).concat(organizationSlug ? "/".concat(organizationSlug) : '', "/profiles/").concat(cert.userId)));
          case 9:
            _context.next = 11;
            return res.json();
          case 11:
            resJson = _context.sent;
            return _context.abrupt("return", _this.setState({
              isRemoving: false,
              removingErr: resJson.message
            }));
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](3);
            return _context.abrupt("return", _this.setState({
              isRemoving: false,
              removingErr: _context.t0.message
            }, _this.hideConfirmDelete));
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 15]]);
    })));
    _defineProperty(_assertThisInitialized(_this), "openRestrictedAccessModal", function () {
      _this.setState({
        isRestrictedAccessModalOpened: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "closeRestrictedAccessModal", function () {
      _this.setState({
        isRestrictedAccessModalOpened: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "openAddVismaSignModal", function () {
      _this.setState({
        isAddVismaSignModalOpened: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "closeAddVismaSignModal", function () {
      _this.setState({
        isAddVismaSignModalOpened: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "openBundleCertDetails", function () {
      _this.setState({
        isBundleCertDetailsOpened: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "closeBundleCertDetails", function () {
      _this.setState({
        isBundleCertDetailsOpened: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleCloseErrSnackbar", function () {
      _this.setState({
        isConfirmDeleteOpen: false,
        isRemoving: false,
        removingErr: ''
      });
    });
    _defineProperty(_assertThisInitialized(_this), "hideConfirmDelete", function () {
      _this.setState({
        isConfirmDeleteOpen: false,
        isRemoving: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "openConfirmDelete", function () {
      _this.setState({
        isConfirmDeleteOpen: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "openShareCertModal", function () {
      _this.setState({
        isShareModalOpened: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "closeShareCertModal", function () {
      _this.setState({
        isShareModalOpened: false
      });
    });
    return _this;
  }
  _createClass(Cert, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (_.get(this, 'context.query.print') !== undefined) {
        setTimeout(function () {
          _this2.print();
        }, 500);
      }
      if (!_.get(this, 'props.cert.file')) {
        this.initWs();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!this.ws) {
        return;
      }
      this.ws.off('certificate_image_generated');
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this,
        _cert$certificateColl,
        _cert$certificateColl2;
      var _this$props4 = this.props,
        cert = _this$props4.cert,
        auth = _this$props4.auth,
        loading = _this$props4.loading,
        formatMessage = _this$props4.intl.formatMessage,
        user = _this$props4.user;
      var _this$state = this.state,
        isRegenerating = _this$state.isRegenerating,
        isRestrictedAccessModalOpened = _this$state.isRestrictedAccessModalOpened,
        isAddVismaSignModalOpened = _this$state.isAddVismaSignModalOpened,
        isBundleCertDetailsOpened = _this$state.isBundleCertDetailsOpened,
        isRemoving = _this$state.isRemoving,
        isConfirmDeleteOpen = _this$state.isConfirmDeleteOpen,
        removingErr = _this$state.removingErr,
        isShareModalOpened = _this$state.isShareModalOpened;
      var hasImage = !!_.get(cert, 'file.path');
      var isBundleCert = !!_.get(cert, 'certificateCollectionId');
      var isBundleCertSigned = _.get(cert, 'vismaSign.status') === VISMA_DOC_STATUSES.signed;
      var isAllowedToSignBundleCert = !isBundleCertSigned && _.get(cert, 'vismaSign.status') !== VISMA_DOC_STATUSES.pending;
      var isDigitalSignatureActiveted = _.get(user, 'mainGroup.certificateCollectionsAndDigitalSignature');
      var isCertOwner = _.get(cert, 'userId') === _.get(auth, 'user._id');
      var isCertPublic = _.get(cert, 'isPublic', false);
      return /*#__PURE__*/_jsx("div", {
        className: s.root
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: s.container
      }, void 0, /*#__PURE__*/_jsx(Paper, {
        className: s.paper
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: s.header
      }, void 0, /*#__PURE__*/_jsx(Typography, {
        variant: "h4",
        component: "h1"
      }, void 0, cert.name), isAllowedToTeacherCreateBundleCert(auth, user) && hasImage && isBundleCert && /*#__PURE__*/_jsx(SignatureStatus, {
        cert: cert
      }), /*#__PURE__*/_jsx("div", {
        className: s.actions
      }, void 0, isDigitalSignatureActiveted && hasImage && isBundleCert && (isAllowedToTeacherCreateBundleCert(auth, user) || cert.userId === _.get(auth, 'user._id')) && /*#__PURE__*/_jsx(Tooltip, {
        title: formatMessage(messages.showDetailsTooltip)
      }, void 0, /*#__PURE__*/_jsx(Button, {
        "data-test-id": "T-Nn68QIyo2vTK2siAvA1",
        variant: "outlined",
        color: "primary",
        className: classNames(s.btn, s.btnEnabled),
        onClick: this.openBundleCertDetails
      }, void 0, /*#__PURE__*/_jsx(ViewIcon, {
        className: s.buttonIcon
      }), /*#__PURE__*/React.createElement(FormattedMessage, messages.showDetailsLabel))), hasImage && /*#__PURE__*/_jsx(Tooltip, {
        title: formatMessage(messages.print)
      }, void 0, /*#__PURE__*/_jsx(Button, {
        "data-test-id": "OUWiAr2mEnckEiVvVfKmP",
        variant: "outlined",
        color: "primary",
        className: classNames(s.btn, s.btnEnabled),
        onClick: isTrial(auth) ? this.openRestrictedAccessModal : this.print
      }, void 0, /*#__PURE__*/_jsx(PrintIcon, {
        className: s.buttonIcon
      }), /*#__PURE__*/React.createElement(FormattedMessage, messages.print))), isSupportAdminAuth(auth) && (cert.courseId || cert.examId || cert.assignmentId || cert.demonstrationId) && /*#__PURE__*/_jsx("div", {
        className: s.buttonWrapper
      }, void 0, /*#__PURE__*/_jsx(Button, {
        "data-test-id": "V0kTxwd7UcssZK_5GMttY",
        variant: "outlined",
        color: "primary",
        className: s.btn,
        onClick: this.regenerate,
        disabled: isRegenerating || loading
      }, void 0, /*#__PURE__*/_jsx(SyncIcon, {
        className: s.buttonIcon
      }), /*#__PURE__*/React.createElement(FormattedMessage, messages.regenerate), (isRegenerating || loading) && /*#__PURE__*/_jsx(CircularProgress, {
        size: 24,
        className: s.buttonProgress
      }))), isDigitalSignatureActiveted && isAllowedToTeacherCreateBundleCert(auth, user) && hasImage && isBundleCert && !_.get(cert, 'vismaSign.signDate') && /*#__PURE__*/_jsx(Tooltip, {
        title: isAllowedToSignBundleCert ? formatMessage(messages.vismaSignTooltip) : ''
      }, void 0, /*#__PURE__*/_jsx("span", {}, void 0, /*#__PURE__*/_jsx(Button, {
        "data-test-id": "CCLYtX9j1ZHQYGSCiYp2t",
        variant: "contained",
        color: "primary",
        className: classNames(s.btn, s.btnEnabled),
        onClick: this.openAddVismaSignModal,
        disabled: !isAllowedToSignBundleCert
      }, void 0, /*#__PURE__*/_jsx(VismaSign, {
        className: s.buttonIcon
      }), /*#__PURE__*/React.createElement(FormattedMessage, messages.vismaSignLabel)))), isSupportAdminAuth(auth) && isBundleCert && /*#__PURE__*/_jsx(ResendVismaSignInvitation, {
        className: classNames(s.btn, s.btnEnabled),
        iconClassName: s.buttonIcon,
        vismaSign: cert.vismaSign,
        submitRoute: "/api/certificates/".concat(cert._id, "/visma-sign/remind"),
        onSuccess: this.refreshVismaSign
      }), hasImage && /*#__PURE__*/_jsx(Tooltip, {
        title: formatMessage(messages.download)
      }, void 0, /*#__PURE__*/_jsx(Button, {
        "data-test-id": "HTptBmI-NSgGtSnzONBQr",
        component: isTrial(auth) ? Button : 'a',
        href: "".concat(this.context.apiUrl, "/api/certificates/").concat(cert._id, "/download"),
        onClick: isTrial(auth) ? function (event) {
          event.preventDefault();
          _this3.openRestrictedAccessModal();
        } : undefined,
        target: "_blank",
        color: "primary",
        variant: "contained",
        className: classNames(s.btn, s.btnEnabled)
      }, void 0, /*#__PURE__*/_jsx(SaveIcon, {
        className: s.buttonIcon
      }), /*#__PURE__*/React.createElement(FormattedMessage, messages.download))), hasImage && isCertPublic && isCertOwner && /*#__PURE__*/_jsx(Tooltip, {
        title: formatMessage(messages.shareBtn)
      }, void 0, /*#__PURE__*/_jsx(Button, {
        "data-test-id": "oJr__M91iSn7Oo8YA0WtL",
        onClick: this.openShareCertModal,
        target: "_blank",
        color: "primary",
        variant: "contained",
        className: classNames(s.btn, s.btnEnabled)
      }, void 0, /*#__PURE__*/_jsx(ShareIcon, {
        className: s.buttonIcon
      }), /*#__PURE__*/React.createElement(FormattedMessage, messages.shareBtn))), isSupportAdminAuth(auth) && isBundleCert && /*#__PURE__*/_jsx(Tooltip, {
        title: formatMessage(messages.removeCertificateBtnLabel)
      }, void 0, /*#__PURE__*/_jsx(Button, {
        "data-test-id": "ziGvHp0GgDk1s4Ilnn4YZ",
        variant: "outlined",
        color: "secondary",
        className: s.btn,
        onClick: this.openConfirmDelete,
        disabled: isRemoving || loading
      }, void 0, _RemoveIcon || (_RemoveIcon = /*#__PURE__*/_jsx(RemoveIcon, {
        color: "secondary"
      })), /*#__PURE__*/React.createElement(FormattedMessage, messages.removeCertificateBtnLabel), isRemoving && /*#__PURE__*/_jsx(CircularProgress, {
        size: 24,
        className: s.buttonProgress
      }))))), /*#__PURE__*/_jsx("div", {
        id: "print-cert",
        className: s.certWrapper
      }, void 0, hasImage && isTrial(auth) && /*#__PURE__*/_jsx("div", {
        className: s.red
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.trial), _br || (_br = /*#__PURE__*/_jsx("br", {})), /*#__PURE__*/React.createElement(FormattedMessage, messages.trial), _br2 || (_br2 = /*#__PURE__*/_jsx("br", {})), /*#__PURE__*/React.createElement(FormattedMessage, messages.trial), _br3 || (_br3 = /*#__PURE__*/_jsx("br", {})), /*#__PURE__*/React.createElement(FormattedMessage, messages.trial), _br4 || (_br4 = /*#__PURE__*/_jsx("br", {})), /*#__PURE__*/React.createElement(FormattedMessage, messages.trial)), hasImage && isBundleCert && /*#__PURE__*/_jsx(NoSsr, {}, void 0, /*#__PURE__*/_jsx(PdfViewer, {
        fileUrl: "".concat(this.context.cloudfrontUrl, "/").concat(_.get(cert, 'pdfFile.path', '')),
        className: s.img
      })), hasImage && !isBundleCert && /*#__PURE__*/_jsx("img", {
        src: "".concat(this.context.cloudfrontUrl, "/").concat(_.get(cert, 'file.path', '')),
        alt: _.get(cert, 'file.name', ''),
        className: s.img
      }), !hasImage && /*#__PURE__*/React.createElement(FormattedMessage, messages.certificateWillBeGeneratedSoon))), /*#__PURE__*/_jsx(Modal, {
        open: isRestrictedAccessModalOpened,
        onClose: this.closeRestrictedAccessModal
      }, void 0, /*#__PURE__*/_jsx(RestrictedAccessModal, {
        onClose: this.closeRestrictedAccessModal
      })), /*#__PURE__*/_jsx(Modal, {
        open: isShareModalOpened,
        onClose: this.closeShareCertModal
      }, void 0, /*#__PURE__*/_jsx(ShareCertificateModal, {
        onClose: this.closeShareCertModal,
        certPage: "".concat(this.props.locale).concat(this.context.organizationSlug ? "/".concat(this.context.organizationSlug) : '', "/cert/").concat(cert.code),
        certId: cert._id
      })), /*#__PURE__*/_jsx(CustomModal, {
        "aria-describedby": "add-visma-sign-modal",
        isOpen: isAddVismaSignModalOpened,
        width: "45%"
      }, void 0, /*#__PURE__*/_jsx(AddVismaSIgnModal, {
        onClose: this.closeAddVismaSignModal,
        onSubmit: this.refreshVismaSign,
        cert: cert,
        submitRoute: "/api/certificates/".concat(cert._id, "/visma-sign?userId=").concat(cert.userId)
      })), /*#__PURE__*/_jsx(BundleCertDetails, {
        isOpen: isBundleCertDetailsOpened && !!cert,
        files: cert === null || cert === void 0 ? void 0 : (_cert$certificateColl = cert.certificateCollectionId) === null || _cert$certificateColl === void 0 ? void 0 : _cert$certificateColl.certificateFiles,
        name: cert.name,
        certificates: cert === null || cert === void 0 ? void 0 : (_cert$certificateColl2 = cert.certificateCollectionId) === null || _cert$certificateColl2 === void 0 ? void 0 : _cert$certificateColl2.certificatesIds,
        ariaDescribedBy: "bundle-cert-details-modal",
        onClose: this.closeBundleCertDetails
      }), /*#__PURE__*/_jsx(ConfirmDeleteDialog, {
        isShown: isConfirmDeleteOpen,
        onClose: this.hideConfirmDelete,
        submit: this.removeBundleCertificate,
        isDeleting: isRemoving,
        deleteBtnId: "confirm-remove-certificate",
        submitColor: "primary",
        deleteBtnLabel: formatMessage(messages.removeCertificateBtnLabel),
        title: /*#__PURE__*/React.createElement(FormattedMessage, messages.confirmRemoveTitle),
        description: /*#__PURE__*/React.createElement(FormattedMessage, isBundleCertSigned || _.get(cert, 'vismaSign.status') === VISMA_DOC_STATUSES.pending ? messages.removingDescriptionWithVismaWarn : messages.removingDescription)
      }), /*#__PURE__*/_jsx(Snackbar, {
        open: !!removingErr,
        onClose: this.handleCloseErrSnackbar,
        autoHideDuration: 3000,
        message: removingErr
      })));
    }
  }]);
  return Cert;
}(React.Component), _defineProperty(_class2, "contextType", AppContext), _class2)) || _class) || _class) || _class) || _class);
export { Cert as default };